export default __webpack_public_path__ + "static/Simple_Rifle_Ammo-901c75313858c39f46bba5d258887a00.png";